/**
 * The message and description to show for a failed API call, in the user's language: translated by the API's
 * error code when the app knows it, else the API's own text, else a generic message (also for a request that
 * never got an answer).
 */
export const apiErrorText = (t, error) => {
    const data = error?.response?.data ?? {};
    const generic = {
        message: t('apiResponses:GENERIC_ERROR.message'),
        description: t('apiResponses:GENERIC_ERROR.description'),
    };

    if (!data.code) {
        return { message: data.message ?? generic.message, description: data.description ?? generic.description };
    }

    return {
        message: t(`apiResponses:${data.code}.message`, { defaultValue: data.message ?? generic.message }),
        description: t(`apiResponses:${data.code}.description`, { defaultValue: data.description ?? '' }),
    };
};
